import React, { useEffect } from 'react';
import classNames from 'classnames';
import { Color } from '../../enums/color';
import { Button } from '../../atoms/button'
import * as styles from './hero.module.sass'
import { Size } from '../../enums/size';
import { Wrapper } from '../../atoms/wrapper';
import { HeroSectionProps } from './props.type';
import { useDispatch, useSelector } from 'react-redux';
import { setModalAction } from '../../../store/modal/factory';
import { ActiveModal } from '../../enums/active-modal';
import { useTranslation } from "../../../i18n/use-translation";
import { getCurrentUserSelector } from "../../../store/auth/selector";
import { HeroSectionType } from "./enum/hero-section-type";


export const HeroSection = (props: HeroSectionProps) => {
	const { t } = useTranslation();
	const dispatcher = useDispatch()
	const { locale } = useTranslation();
	const user = useSelector(getCurrentUserSelector);
	const expertsLink = 'experts';
	const createCompanyLink = 'cabinet/register-company';
	const cabinetScheduleLink = 'cabinet/schedule';
	const roleModalHandler = () => dispatcher(setModalAction(ActiveModal.ROLE));
	const redirectToLinkHandler = () => {
		switch (props.heroSectionType) {
			case HeroSectionType.DOCTOR:
				return document.location.href = `/${locale}/${cabinetScheduleLink}`;
			case HeroSectionType.CLINIC:
				return document.location.href = `/${locale}/${createCompanyLink}`;

			default:
				return document.location.href = `/${locale}/${expertsLink}`;
		}
	}
	const redirectToRegisterHandler = () => {
		return document.location.href = `${window.location.origin}/?showModal=register`;
	}
	const redirectToLoginHandler = () => {
		return document.location.href = `${window.location.origin}/?showModal=login`;
	}

	const heroButton = (): any => {
		switch (props.heroSectionType) {
			case HeroSectionType.PATIENT:
				return {
					button_text: t(!user ? 'sign_registr' : 'search_specialist'),
					action: !user ? redirectToRegisterHandler : redirectToLinkHandler,
				};
			case HeroSectionType.DOCTOR:
				return {
					button_text: t(!user ? 'create_specialist_cabinet' : 'profile_schedules'),
					action: !user ? redirectToRegisterHandler : redirectToLinkHandler,
				};
			case HeroSectionType.CLINIC:
				return {
					button_text: t('register_clinic'),
					action: !user ? redirectToRegisterHandler : redirectToLinkHandler,
				};

			default:
				return {
					button_text: t(!user ? 'sign_registr' : 'search_specialist'),
					action: !user ? redirectToRegisterHandler : redirectToLinkHandler,
				};
		}
	}

	return (
		<Wrapper background_color={props.background_color} cardClassName={styles.inside} className={classNames(styles.hero, styles.img)}>
			<h1 className={classNames(props.className, styles.heading)}>{props.title}</h1>
			<Button color={Color.EMPTY} size={Size.BIG} text={heroButton().button_text} onClick={heroButton().action} className={styles.button} />
		</Wrapper>
	)
}
